import React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import shortid from "shortid";
import CheckFileType from "../../utils/CheckFileType";

export default function ReceiptForm({
  name,
  address,
  city,
  setName,
  setAddress,
  setCity,
  priceSymbol,
  setPriceSymbol,
  taxFields,
  setTaxFields,
  itemFields,
  setItemFields,
  fontFamily,
  setFontFamily,
  tankYouNote,
  setTankYouNote,
  checked,
  setBusinessLogo,
}) {
  const handelTaxChangeInput = (e, index) => {
    const values = [...taxFields];
    values[index][e.target.name] = e.target.value;
    setTaxFields(values);
  };
  const handelItemChangeInput = (e, index) => {
    const values = [...itemFields];
    values[index][e.target.name] = e.target.value;
    setItemFields(values);
  };
  const addAnotherTax = () => {
    setTaxFields([
      ...taxFields,
      {
        id: shortid.generate(),
        taxType: "VAT",
        taxPercent: "5",
      },
    ]);
  };
  const addAnotherItem = () => {
    setItemFields([
      ...itemFields,
      {
        id: shortid.generate(),
        description: "Chai Tea Latte - Garden",
        qty: 1,
        price: 0,
      },
    ]);
  };
  const removeTaxField = (id) => {
    const values = taxFields.filter((field) => field.id !== id);
    setTaxFields(values);
  };
  const removeItemField = (id) => {
    const values = itemFields.filter((field) => field.id !== id);
    setItemFields(values);
  };
  const removeAllItem = () => {
    setItemFields([]);
  };
  const handelFileUpload = (event) => {
    var file = event.target.files[0];
    if (CheckFileType(file)) {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          // convert image file to base64 string
          setBusinessLogo(reader.result);
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    } else {
      alert("Please Add a valid image file!");
      console.log(file);
    }
  };
  return (
    <section className="mt-4">
      <div
        className={`${
          checked ? "hidden" : null
        } business-name my-4 -mt-2 flex flex-col`}
      >
        <label className="block text-xs mb-1" htmlFor="business-name">
          Business Name
        </label>
        <input
          id="business-name"
          type="text"
          aria-label="business-name"
          className="input h-10  border border-gray-500 px-2 focus:outline-none"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className={`${!checked ? "hidden" : null} upload-file my-4 -mt-2`}>
        <label className="block text-xs mb-1" htmlFor="upload-logo">
          Upload your logo
        </label>
        <input
          id="upload-logo"
          type="file"
          aria-label="upload-logo"
          accept="image/*"
          className="input border-gray-500 focus:outline-none"
          onChange={(e) => handelFileUpload(e)}
        />
      </div>

      <div className="business-address mb-6 flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 lg:pr-1">
          <label className="block text-xs mb-1" htmlFor="business-address">
            Business Address
          </label>
          <input
            id="business-address"
            type="text"
            aria-label="business-address"
            className="input h-10 w-full border border-gray-500 px-2 focus:outline-none mb-4 lg:mb-0"
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
        <div className="w-full lg:w-1/2 lg:pl-1">
          <label className="block text-xs mb-1" htmlFor="city-state">
            City, State
          </label>
          <input
            id="city-state"
            type="text"
            aria-label="city-state"
            className="input h-10 w-full border border-gray-500 px-2 focus:outline-none"
            placeholder="City, State"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>
      </div>
      <div className="business-address mb-6 flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 lg:pr-1">
          <label className="block text-xs mb-1" htmlFor="symbol">
            Currency
          </label>
          <input
            id="symbol"
            type="text"
            aria-label="symbol"
            className="input h-10 w-full border border-gray-500 px-2 focus:outline-none uppercase mb-4 lg:mb-0"
            placeholder="Currency symbol ex: $"
            value={priceSymbol}
            onChange={(e) => setPriceSymbol(e.target.value)}
          />
        </div>
        <div className="w-full lg:w-1/2 lg:pl-1">
          <label className="block text-xs mb-1" htmlFor="city-state">
            Font Style
          </label>
          <select
            id="city-state"
            aria-label="font-style"
            className="input h-10 w-full border border-gray-500 px-2 focus:outline-none"
            value={fontFamily}
            onBlur={(e) => setFontFamily(e.target.value)}
            onChange={(e) => setFontFamily(e.target.value)}
          >
            <option value="sans-serif">Font Style 1</option>
            <option value="serif">Font Style 2</option>
            <option value="cursive">Font Style 3</option>
            <option value="fantasy">Font Style 4</option>
            <option value="monospace">Font Style 5</option>
          </select>
        </div>
      </div>
      <div className="extracharger-container mb-4">
        <p className="font-semibold mb-2 ">Extra charges</p>
        <TransitionGroup className="tax-group">
          {taxFields.map((field, index) => {
            return (
              <CSSTransition key={field.id} timeout={500} classNames="item">
                <div className="tax-currency mb-4 flex items-end">
                  <div className="tax-type">
                    <label className="block text-xs" htmlFor="taxType">
                      Tax type
                    </label>
                    <input
                      type="text"
                      name="taxType"
                      aria-label="taxType"
                      className="input h-8 w-16 border border-gray-500 px-2 focus:outline-none uppercase"
                      placeholder="Tax"
                      value={field.taxType}
                      onChange={(e) => handelTaxChangeInput(e, index)}
                    />
                  </div>
                  <div className="w-2"></div>
                  <div className="tax-parcent">
                    <label className="block text-xs" htmlFor="taxPercent">
                      Tax parcent
                    </label>
                    <input
                      type="number"
                      name="taxPercent"
                      aria-label="taxPercent"
                      className="input h-8 w-16 border border-gray-500 px-2 focus:outline-none"
                      placeholder="tax %"
                      value={field.taxPercent}
                      onChange={(e) => handelTaxChangeInput(e, index)}
                    />
                  </div>
                  <div className="text-2xl px-2">%</div>
                  <button
                    className="hover:bg-purple-700 hover:text-white px-1 h-8 rounded"
                    onClick={() => removeTaxField(field.id)}
                    aria-label="Remove this tax field"
                  >
                    <i className="demo-icon icon-trash-empty text-xl"></i>
                  </button>
                </div>
              </CSSTransition>
            );
          })}
        </TransitionGroup>
        <div className="add-another mt-6">
          <button
            onClick={() => addAnotherTax()}
            className="bg-purple-700 text-white px-4 py-1"
            aria-label="Add another tax field"
          >
            {taxFields.length ? "Add another tax" : "Add a tax"}
          </button>
        </div>
      </div>
      <div className="purchess-item">
        <p className="font-semibold mb-1">Add your items</p>
        <TransitionGroup className="item-group">
          {itemFields.map((itemField, index) => {
            return (
              <CSSTransition key={itemField.id} timeout={500} classNames="item">
                <div className="add-item flex flex-wrap items-end mb-4">
                  <div className="item-description">
                    <label htmlFor="description" className="text-xs block">
                      Description
                    </label>
                    <input
                      type="text"
                      name="description"
                      aria-label="description"
                      className="input h-8 w-56 border border-gray-500 px-2 focus:outline-none"
                      placeholder="Chai Tea Latte - Garden"
                      value={itemField.description}
                      onChange={(e) => handelItemChangeInput(e, index)}
                    />
                  </div>
                  <div className="w-2 h-2"></div>
                  <div className="item-price">
                    <label htmlFor="price" className="text-xs block">
                      Price
                    </label>
                    <input
                      type="number"
                      name="price"
                      min="1"
                      aria-label="price"
                      className="input h-8 w-16 border border-gray-500 px-2 focus:outline-none"
                      placeholder="4.75"
                      value={itemField.price}
                      onChange={(e) => handelItemChangeInput(e, index)}
                    />
                  </div>
                  <div className="w-2 h-2"></div>
                  <div className="item-quantity">
                    <label htmlFor="qty" className="text-xs block">
                      Qty
                    </label>
                    <input
                      type="number"
                      min="1"
                      name="qty"
                      aria-label="qty"
                      className="input h-8 w-10 border border-gray-500 px-2 focus:outline-none"
                      placeholder="2"
                      value={itemField.qty}
                      onChange={(e) => handelItemChangeInput(e, index)}
                    />
                  </div>
                  <button
                    className="hover:bg-purple-700 hover:text-white px-1 h-8 rounded ml-2"
                    onClick={() => removeItemField(itemField.id)}
                    aria-label="remove this item field"
                  >
                    <i className="demo-icon icon-trash-empty text-xl"></i>
                  </button>
                </div>
              </CSSTransition>
            );
          })}
        </TransitionGroup>
        <div className="add-another my-4 mt-6">
          <button
            className="bg-purple-700 text-white px-4 py-1"
            onClick={() => addAnotherItem()}
            aria-label="Add another item"
          >
            {itemFields.length ? "Add another item" : "Add an item"}
          </button>
          <button
            className={`${
              itemFields.length
                ? "bg-gray-700 text-white"
                : "opacity-50 cursor-not-allowed"
            } px-4 py-1 ml-2`}
            disabled={!itemFields.length}
            onClick={() => removeAllItem()}
            aria-label="remove all items"
          >
            <i className="demo-icon icon-trash-empty mr-1"></i>
            Delete all
          </button>
        </div>
        <div className="thankyou">
          <label htmlFor="thank-you-note" className="text-xs block">
            Thank you note
          </label>
          <input
            type="text"
            name="thank-you-note"
            aria-label="thank-you-note"
            className="input h-8 w-full border border-gray-500 px-2 focus:outline-none"
            value={tankYouNote}
            onChange={(e) => setTankYouNote(e.target.value)}
            placeholder="Note for the bottom of the receipt."
          ></input>
        </div>
      </div>
    </section>
  );
}
